<template>
  <div style="text-align: left">
    <div style="margin-bottom: 10px">
      <el-button
        type="primary"
        class="add"
        v-role="['3','1']"
        size="small"
        @click="publisharticle"
      >
        <i class="el-icon-plus"></i>
        发布消息通知
      </el-button>
      <el-button
        type="danger"
        v-role="['3']"
        size="small"
        class="delete"
        @click="delMulData"
      >
        <i class="el-icon-delete"></i>删除
      </el-button>
    </div>
    <div>
      <div class="box">
        <el-form :inline="true" size="mini">
          <el-form-item label="标题">
            <el-input
              placeholder="请输入标题"
              clearable
              v-model="searchForm.title"
            ></el-input>
          </el-form-item>
          <el-button
            type="primary"
            size="small"
            @click="doSearch"
            class="queryBtn"
            >查询</el-button
          >
        </el-form>
      </div>
    </div>
    <el-table
      ref="multipleTable"
      :data="tableListData"
      tooltip-effect="dark"
      style="width: 100%; position: relative"
      border
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        min-width="40"
        align="center"
      ></el-table-column>
      <el-table-column
        width="80"
        prop="id"
        label="序号"       
        align="center"
      >
    <template slot-scope="scope">
      {{ (searchForm.page - 1) * searchForm.pageSize + scope.$index + 1 }}
    </template>
    </el-table-column>
      <el-table-column
        prop="title"
        align="center"
        label="标题"
      ></el-table-column>
      <el-table-column
        prop="createTime"
        align="center"
        label="发布时间"
      ></el-table-column>
      <el-table-column
        prop="operation"
        label="操作"
        width="100"
        fixed="right"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            @click="deleteArticle(scope.row)"
            class="btn"
            size="small"
            >删除</el-button
          >
          <el-button
            type="text"
            size="small"
            @click="editArticle(scope.row)"
            class="btn"
            >编辑</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="paging">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchForm.page"
        :page-sizes="[1, 5, 15, 20, 50, 100]"
        :page-size="searchForm.pageSize"
        background
        layout="prev, pager, next,total, sizes, jumper"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import API from '../apis/article'

export default {
  data () {
    return {
      isLoading: false,
      multipleSelection: [],
      total: 0,
      tableListData: [],
      searchForm: {
        name: null,
        page: 1,
        pageSize: 15,
      }
    }
  },
  methods: {
    editArticle (row) {
      this.$router.push({ path: '/publisharticle', query: { id: row.id } });
    },
    publisharticle () {
      this.$router.push('/publisharticle');
    },
    handleSizeChange: function (val) {
      this.searchForm.pageSize = val;
      this.search()
    },
    handleCurrentChange: function (val) {
      this.searchForm.page = val;
      this.search()
    },
    doSearch () {
      this.searchForm.page = 1
      this.search()
    },
    search: function () {
      let params = Object.assign({}, this.searchForm);
      API.getList(params).then((result) => {
        if (result && result.code == 0) {
          this.tableListData = result.result.data;
          this.total = result.result.recordCount;
        }
        else {
          this.$message.error({ showClose: true, message: result.result.message, duration: 2000 });
        }
      }).catch((error) => {
        this.$message.error({ showClose: true, message: '请求出现异常', duration: 2000 });
      });
    },

    handleSelectionChange (val) {
      this.multipleSelection = val;
    },

    deleteArticle (row) {
      let params = { id: row.id };
      this.$confirm('确认删除记录吗？', '提示', { type: 'warning' }).then(() => {
        API.delete(params).then((result) => {
          if (result.code == 0) {
            this.$message.success({ showClose: true, message: '删除成功', duration: 2000 });
            this.search();
          } else {
            this.$message.error({ showClose: true, message: '系统错误', duration: 2000 });
          }
        }).catch((error) => {
          this.$message.error({ showClose: true, message: '123', duration: 2000 })
        })
      }).catch(() => { })
    },
    /*批量删除*/
    delMulData () {
      let that = this;
      let val = that.multipleSelection
      let idArray = [];
      for (var i = 0; i < val.length; i++) {
        idArray.push(val[i].id)
      }
      this.$confirm('此操作将永久删除该数据，是否继续？', '提示', {
        confimButtonTexe: '确定',
        cancelButtonTexe: '取消',
        type: 'warning'
      }).then(() => {
        if (idArray) {
          API.deleteBatch({ ids: idArray.join() }).then(function (result) {
            that.loading = false;
            if (result && result.code == 0) {
              that.$message.success({ showClose: true, message: '删除成功', duration: 2000 });
              that.search()
            } else {
              that.$message.error({ showClose: true, message: '删除操作异常，请重试', duration: 2000 });
            }
          }, function (err) {
            that.loading = false;
            that.$message.error({ showClose: true, message: err.toString(), duration: 2000 });
          }).catch(function (error) {
            that.loading = false;
            console.log(error);
            that.$message.error({ showClose: true, message: '请求出现异常', duration: 2000 });
          })
        }
      })
      this.$refs.multipleTable.clearSelection()
    }
  },
  computed: {
  },
  mounted () {
    this.search()
  }
}
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/Article.vue